import { unsubscribeEmailRequest, unsubscribeEmailResponse } from "./email.dto";
import { apiV2 } from "./v2";

/**
 * Anonymous: the signed token is the credential. The `List-Unsubscribe` one-click POST (RFC 8058) and the unsubscribe
 * page both call it; it turns that kind of digest off.
 */
export const unsubscribeEmailApi = apiV2("POST", "/email/unsubscribe/:token").withRequest(unsubscribeEmailRequest).withResponse(unsubscribeEmailResponse);

/** A mail client that opens the `List-Unsubscribe` URL in a browser is sent on to the unsubscribe page. */
export const unsubscribeEmailPageApi = apiV2("GET", "/email/unsubscribe/:token").withRequest(unsubscribeEmailRequest);
